/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_ProofInputs */

const en_case_doc_proof = /** @type {(inputs: Case_Doc_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Income/billing proof`)
};

const pt_br2_case_doc_proof = /** @type {(inputs: Case_Doc_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprovante de rendimentos/faturamento`)
};

/**
* | output |
* | --- |
* | "Income/billing proof" |
*
* @param {Case_Doc_ProofInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_proof = /** @type {((inputs?: Case_Doc_ProofInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_ProofInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_proof(inputs)
	return pt_br2_case_doc_proof(inputs)
});